import { FC } from 'react';
import useJurisdiction from '../../../hooks/useJurisdiction';

const Navbar: FC = () => {
    const {
        requestTitle,
        requestLogoUrl,
        requestUrl
    } = useJurisdiction();
    
    return (
        <nav>
            <div className="w-full mx-auto px-4 sm:px-6 lg:px-8 _bg-white shadow-md theme-header">
                <div className="flex items-center justify-between h-28">
                    <div className="flex items-center">
                        <div className="md:flex-shrink-0">
                            <a href={requestUrl}>
                                {requestLogoUrl && (
                                    <img
                                        className="max-h-28"
                                        src={requestLogoUrl}
                                        alt="Workflow"
                                        title="request"
                                    />
                                )}

                                {!requestLogoUrl && (
                                    <h1 className="font-bold text-4xl _text-purple-600 theme-header-title">{requestTitle}</h1>
                                )}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;